import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { IconButton, Typography, Button } from '@material-ui/core';

import { inputFieldNames } from '../../constants';

import ReviewList from './ReviewList';
import { submitMode } from '../../constants';
import AddHazardReviewDialog from '../../containers/AddHazardReviewDialog';

const useStyles = makeStyles((theme) => ({
  simpleLabel: {
    display: 'inline-block',
    marginTop: 2
  },
  editHazardFieldsContainer: {
    padding: theme.spacing(2)
  },
  backArrow: {
    marginLeft: -16
  },
  courseName: {
    fontWeight: 600
  },
  addControlButton: {
    marginTop: 8
  }
}));

const HazardReviewPanel = (props) => {
  const {
    hazard,
    openHazardReviewPanel,
    fetchReviewsForTheHazard,
    reviews,
    onHandleDeleteHazardReviewClick,
    submitReview,
    enableEditHazardReview,
    isEditReviewEnabled,
    reviewBeingEdited,
    onHandleEditHazardReviewInputChange,
    onOpenAddHazardReviewDialog,
    openAddHazardReviewDialog,
    onOpenDeleteHazardReviewDialog,
    showDeleteReviewDialog,
    userId,
    onRemoveAttachment,
    allAttachments,
    branchId
  } = props;
  const classes = useStyles();

  React.useEffect(() => {
    fetchReviewsForTheHazard(hazard.id);
  }, [hazard.id]);

  const handleEditHazardReviewInputChange = (e, inputfieldName) => {
    if (
      inputfieldName === inputFieldNames.REVIEW_REVIEW_DATE ||
      inputfieldName === inputFieldNames.HAZARD_REVIEW_ATTACHMENT
    ) {
      onHandleEditHazardReviewInputChange(e, inputfieldName);
    } else {
      onHandleEditHazardReviewInputChange(e.target.value, inputfieldName);
    }
  };

  const handleDeleteHazardReviewClick = (reviewId) => {
    const payload = {
      hazardId: hazard.id,
      reviewId
    };
    onHandleDeleteHazardReviewClick(payload);
  };

  const handleSaveHazardReviewClick = (e) => {
    e.preventDefault();
    const payload = {
      ...reviewBeingEdited
    };
    submitReview(payload, submitMode.UPDATE, branchId);
  };

  const handleOpenDeleteReviewClick = (open, reviewId) => {
    onOpenDeleteHazardReviewDialog(open, reviewId);
  };

  const handleRemoveAttachment = (attachment) => {
    onRemoveAttachment(attachment);
  };

  return (
    <React.Fragment>
      {openAddHazardReviewDialog ? <AddHazardReviewDialog /> : null}

      <div className={classes.backArrowContainer}>
        <IconButton
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => openHazardReviewPanel(false)}
          id="settings-button"
          className={classes.backArrow}
        >
          <ArrowBackIcon color="primary" />
        </IconButton>
        <Typography className={classes.simpleLabel}>Hazards</Typography>
      </div>

      <div className={classes.courseNameContainer}>
        <Typography className={classes.courseName}>
          {hazard.description}
        </Typography>
      </div>

      <Button
        color="primary"
        variant="contained"
        className={classes.addControlButton}
        onClick={() => onOpenAddHazardReviewDialog(true)}
      >
        Add Hazard Review
      </Button>

      <ReviewList
        reviews={reviews}
        handleDeleteHazardReviewClick={handleDeleteHazardReviewClick}
        enableEditHazardReview={enableEditHazardReview}
        isEditReviewEnabled={isEditReviewEnabled}
        reviewBeingEdited={reviewBeingEdited}
        handleEditHazardReviewInputChange={handleEditHazardReviewInputChange}
        handleSaveHazardReviewClick={handleSaveHazardReviewClick}
        handleOpenDeleteReviewClick={handleOpenDeleteReviewClick}
        showDeleteReviewDialog={showDeleteReviewDialog}
        userId={userId}
        handleRemoveAttachment={handleRemoveAttachment}
        allAttachments={allAttachments}
      />
    </React.Fragment>
  );
};

export default HazardReviewPanel;
